import { ObjectDb } from './object.db';
import { FolderMedicationGridItemObject } from '@it2go/types';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FolderMedicationDb extends ObjectDb<FolderMedicationGridItemObject> {

    public tableName: string = 'folderMedication';

    protected override columnMap = {
        folderId: 'folderId',
        active: 'active',
        from: 'from',
        to: 'to',
    };

    protected override indices = ['id', 'folderId'];

    protected gqlMethod = 'getFolderMedications';

    protected syncFragment = `
        id
        medicationCode
        updatedAt
        folderId
        active
        from
        to
        dosingPeriod {
            custom
            days
            hours
        }
        dosing {
            morning
            forenoon
            noon
            afternoon
            evening
            night
            hours
        }
        connectedProcedures {
            applications
            code
            voucherPrescribedMedicalProcedureId
        }
    `;

}
